import React from 'react';
import { Link } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';

const externalLinks = [
  {
    title: 'Reporte Imagenológico Dentomaxilofacial',
    path: 'https://publicaciones.svrid.org.ve/index.php/rid',
    external: true,
  },
  {
    title: 'IADMFR',
    path: 'https://iadmfr.one/',
    external: true,
  },
  {
    title: 'SROyMF',
    path: 'http://www.sociedadradiologíaoral.cl/',
    external: true,
  },
  {
    title: 'AADIMAX',
    path: 'http://aadimax.com.ar/',
    external: true,
  },
];

interface NavLinkProps {
  path: any;
  title: any;
  external: any;
}

function NavLink({ path, title, external }: NavLinkProps) {
  return (
    <li key={path} className="py-1 my-1">
      {!external ? (
        <Link className="" to={path}>
          {title}
        </Link>
      ) : (
        <a href={path} rel="noopener noreferrer" target="_blank">
          {title}
        </a>
      )}
    </li>
  );
}

interface FooterProps {
  links: Array<any>;
}

export default function Footer({ links = [] }: FooterProps) {
  const [items, setItems] = React.useState([]);
  React.useEffect(() => {
    setItems(
      links
        .map((link) => {
          let element = [];
          if (link.subItems) {
            element = link.subItems.map((_link) => (
              <NavLink {..._link} key={_link.path} />
            ));
          }
          element.push(<NavLink key={link.path} {...link} />);
          return element;
        })
        .flat(Infinity)
    );
  }, [links]);
  return (
    <footer className="relative bottom-0 left-0 w-full z-10 pt-4 flex flex-col flex-wrap">
      <h3 className="text-3xl font-semibold px-16 text-gray-700 text-center">
        Patrocinantes
      </h3>
      <p className="px-16 text-center text-gray-500 mb-8 mt-2">
        Dale click al logo de nuestros patrocinantes
      </p>
      <div className="div w-full px-16 flex flex-row flex-wrap justify-center mb-8">
        <div className="w-full md:w-auto md:flex-1 mb-8 max-w-md">
          <a
            href="https://www.tecnimed.co/"
            rel="noopener noreferrer"
            target="_blank"
          >
            <StaticImage src="../../images/sponsor-0.png" alt="Tecnimed" />
          </a>
        </div>
      </div>
      <div className="div w-full px-16 flex flex-row flex-wrap justify-center mb-8">
        <div className="w-full md:w-auto md:flex-1 mb-8">
          <a
            href="http://www.implantesmis.com.ve/"
            rel="noopener noreferrer"
            target="_blank"
          >
            <StaticImage
              src="../../images/sponsor-1.png"
              alt="Implantes Dentales Mis"
            />
          </a>
        </div>
        <div className="w-full md:w-auto md:flex-1 mb-8">
          <a
            href="http://www.cmdlt.edu.ve/odontoimagen/index.html"
            rel="noopener noreferrer"
            target="_blank"
          >
            <StaticImage src="../../images/sponsor-2.jpg" alt="Odonto Imagen" />
          </a>
        </div>
        <div className="w-full md:w-auto md:flex-1 mb-8">
          <a
            href="https://www.instagram.com/Orthodonca/"
            rel="noopener noreferrer"
            target="_blank"
          >
            <StaticImage src="../../images/sponsor-3.png" alt="Orthodonca" />
          </a>
        </div>
        <div className="w-full md:w-auto md:flex-1 mb-8">
          <a
            href="https://www.instagram.com/p/CCHOvKdKoQV/?igshid=waz5ci34p7zj"
            rel="noopener noreferrer"
            target="_blank"
          >
            <StaticImage
              src="../../images/sponsor-4.jpg"
              alt="Digital Dental Planning"
            />
          </a>
        </div>
        {/* <div className="w-full md:w-auto md:flex-1 mb-8">
          <a
            href="https://www.instagram.com/sepanorca/"
            rel="noopener noreferrer"
            target="_blank"
          >
            <StaticImage src="../../images/sponsor-5.png" alt="Sepanorca" />
          </a>
        </div> */}
      </div>
      <div className="bg-gray-700 text-gray-50 w-full pt-4">
        <div className="px-8 text-white flex flex-row flex-wrap justify-center mb-4">
          <div className="w-full md:w-3/12">
            <h3 className="text-lg mb-4 font-semibold">Navegación</h3>
            <nav>
              <ul>{items}</ul>
            </nav>
          </div>
          <div className="w-full md:w-3/12">
            <h3 className="text-lg mb-4 font-semibold">Links de Interés</h3>
            <nav>
              <ul>
                {externalLinks.map((link) => (
                  <NavLink key={link.path} {...link} />
                ))}
              </ul>
            </nav>
          </div>
          <div className="w-full md:w-3/12">
            <nav>
              <h3 className="text-lg mb-4 font-semibold">Únete</h3>
              <form
                className="flex flex-col flex-wrap w-full validate"
                method="POST"
                action="https://svrid.us17.list-manage.com/subscribe/post?u=88eb7c2bb6e657edab60a938d&amp;id=1aec3da031"
                id="mc-embedded-subscribe-form"
                name="mc-embedded-subscribe-form"
                target="_blank"
                noValidate
              >
                <label className="text-lg" htmlFor="mce-EMAIL">
                  Recibir Noticias
                  <input
                    className="bg-gray-500 px-3 py-2 w-full rounded-full mt-2 shadow-xl focus:outline-none placeholder-gray-300 text-sm required email"
                    placeholder="Correo Electrónico"
                    type="email"
                    name="EMAIL"
                    id="mce-EMAIL"
                    required
                  />
                </label>
                <div className="hidden" aria-hidden="true">
                  <input
                    type="text"
                    name="b_88eb7c2bb6e657edab60a938d_1aec3da031"
                    tabIndex={-1}
                    defaultValue=""
                  />
                </div>
                <input
                  type="submit"
                  name="subscribe"
                  id="mc-embedded-subscribe"
                  value="Suscribirse"
                  className="bg-blue-700 p-1 text-center w-auto rounded-full mt-2 shadow-xl focus:outline-none cursor-pointer"
                />
              </form>
            </nav>
          </div>
        </div>
        <p className="px-8 py-3 bg-gray-900">
          © {new Date().getFullYear()} Sociedad Venezolana de Radiología e
          Imagenología Dentomaxilofacial.
          {` `}
        </p>
      </div>
    </footer>
  );
}
